import styled, {keyframes} from 'styled-components';
import PropTypes from 'prop-types';

export const FormWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin-top: 20px;
`;

export const FormFieldsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const AccountCategory = styled.div`
  color: #ababab;
  width: 250px;
  padding-right: 20px;
  padding: 10px;
  float: left;
  background: #f7f7f8;
`;

export const GroupWrapper = styled.div`
  margin-top: 0.5em;
  padding: 0 1rem 0.5rem 1rem;
  background-color: #f5f6f7;
  border: 1px solid #e2e2e2;
`;

export const BrpGroupWrapper = styled.div`
  margin-top: 1em;
  padding: 0 1rem 1rem 1rem;
`;

export const BrpGroupTitle = styled.div`
  margin-top: 20px;
  color: rgb(73, 22, 109);
  font-size: 1.2rem;
`;

export const GroupTitle = styled.div`
  margin-top: 10px;
`;

export const SummaryGroupWrapper = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    props.value === true ? '5fr 0fr' : '400px 1fr'};
  border: 1px solid #eaeaea;
  border-radius: 5px;
  margin-top: 0.25rem;
`;

export const SummaryCategory = styled.div`
  color: #ababab;
  width: 100%;
  max-width: ${props => (props.value === true ? '100%' : '400px')};
  padding: 10px;
  background: #f7f7f8;
`;

export const SummaryDetail = styled.div`
  padding: 10px;
  background: #ffffff;
`;

export const ModalFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Button = styled.button`
  margin: 0.5em auto;
  width: 20%;
`;

export const FieldWrapper = styled.div`
  margin: 1em 0;
`;

const BtnMarginAll = styled.button`
  ${({ mt, mb, ml, mr }) => {
    let style = '';
    if (mt) style += `margin-top: ${mt};`;
    if (mb) style += `margin-bottom: ${mb};`;
    if (ml) style += `margin-left: ${ml};`;
    if (mr) style += `margin-right: ${mr};`;
    return style;
  }}
`;

BtnMarginAll.propTypes = {
  mt: PropTypes.string,
  mb: PropTypes.string,
  ml: PropTypes.string,
  mr: PropTypes.string
};

BtnMarginAll.defaultProps = {
  mt: null,
  mb: null,
  ml: null,
  mr: null
};

export const BtnMargin = BtnMarginAll;

export const RowBordered = styled(FormFieldsWrapper)`
  position: relative;
  border: 1px solid #8c68a6;
  padding: 10px;
  margin-top: 10px;
`;
export const LocationWrapper = styled.div`
  margin-top: 1em;
`;

export const LocationGroupTitle = styled.div`
  margin-top: 20px;
  color: #4b286d;
  font-size: 1.2rem;
  font-weight: 700;
`;

export const LocationButton = styled.button`
  border: none;
  padding: 0;
  cursor: pointer;
  background: none;
  color: #4b286d;
  font-size: 14px;

  :hover {
    text-decoration: underline;
  }
`;

export const Bold = styled.b`
  font-weight: bold;
`;

export const FullWidth = styled.div`
  width: 100%;
`;

const FloatDiv = styled.div`
  ${props => {
    let style = '';
    if (props.float) {
      style += `float: ${props.float}`;
    }

    return style;
  }}
`;

FloatDiv.propTypes = {
  float: PropTypes.string
};

FloatDiv.defaultProps = {
  float: null
};

export const Float = FloatDiv;

export const TopRight = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 999;
`;

export const EquipmentSectionWrapper = styled.div`
  display: flex;
  flex-flow: column;
  flex: 0 1 calc((100% - 48px) / 3); /* Three columns: parent gap 24px × 2 = 48px, rest divided equally */
  box-sizing: border-box;
  max-width: calc((100% - 48px) / 3);
  min-width: 0; /* Allow shrink so gap remains visible */
  margin: 0;
  margin-top: 10px;
`;

export const EquipmentSectionTitle = styled.div`
  margin-bottom: 10px;
  color: #4b286d;
  font-weight: 700;
`;

export const EquipmentSectionSubTitle = styled.div`
  margin-bottom: 10px;
  color: black;
`;

export const InlineRepeatedFormField = styled.div`
  display: inline-block;
  width: 50%;
  vertical-align: top;
`;

export const FormStepImageContainer = styled.div`
  width: 36%;
  min-width: 350px;
  margin-left: 1rem;
`;

export const FormStepContainerBRP = styled.div`
  max-width: 1140px;
  border: 1px solid rgb(227, 227, 227);
  box-shadow: rgb(227 227 227) 1px 1px 9px 4px;
  padding: 2rem;
  margin: 1rem auto;
  margin-bottom: 15rem;
  padding-bottom: 11rem;
`;

export const ErrorMessageWrapper = styled.div`
  color: red;
  margin-top: 1rem;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const DiscountApplicationChip = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: white;
  background-color: rgb(43, 128, 0);
  padding: 2px 2px;
  border-radius: 16px;
  animation: ${fadeIn} 0.3s ease-in-out;
`;

export const DiscountApplicationChipNotch = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: white;
  margin: 0px 12px;
`;

export const TabBarWrapper = styled.div`
  max-width: 90vw;
  margin: 0 auto;
  width: 100%;
`;
